import {Card, Form, FormButton, FormField} from 'platform/components';
import {Center, VStack} from 'platform/foundation';
import {z} from 'zod';

import i18n from '@dms/i18n';

const schema = z.object({
  make: z.string().trim().min(1, i18n.t('general.notifications.requiredMake')),
  model: z.string().trim().min(1, i18n.t('general.notifications.requiredModel')),
});

export type VehicleFields = z.infer<typeof schema>;

type CompleteSourcingVehicleFieldsProps = VehicleFields & {
  onContinue: (fields: VehicleFields) => void;
};

export function CompleteSourcingVehicleFields(props: CompleteSourcingVehicleFieldsProps) {
  return (
    <Center>
      <Card title={i18n.t('entity.mandatoryFields.errorModal.heading')}>
        <Form<VehicleFields>
          onSubmit={(fields) => {
            props.onContinue(fields);
            return Promise.resolve();
          }}
          experimentalZodSchema={schema}
          defaultValues={{make: props.make, model: props.model}}
        >
          {(control) => (
            <VStack spacing={4}>
              <FormField
                control={control}
                name="make"
                type="text"
                isRequired
                label={i18n.t('entity.vehicle.labels.make')}
              />
              <FormField
                control={control}
                name="model"
                type="text"
                isRequired
                label={i18n.t('entity.vehicle.labels.model')}
              />
              <FormButton
                control={control}
                type="submit"
                title={i18n.t('general.actions.continue')}
              />
            </VStack>
          )}
        </Form>
      </Card>
    </Center>
  );
}
